export default __webpack_public_path__ + "static/media/provesional_restoration_upper_27_4@2x.f47920ff.png";